<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <template v-if="!!category">
          <div class="col-4">
            <div class="position-relative">
              <img
                class="w-100"
                :src="category.image" 
                @click="toggleModal"
              >
              <i class="fa fa-search-plus magnifying-glass position-absolute color-sachlich-white" />
            </div>
            
            <Modal 
              :show="modal" 
              :close="toggleModal" 
              size="medium"
            >
              <div 
                class="modal-image-container d-flex justify-content-center"
                @click="toggleModal" 
              >
                <img 
                  :src="category.image"
                  class="position-relative w-100 mt-3"
                >
              </div>
            </Modal>
          </div>

          <div class="col-7">
            <div class="description lh-base">
              <div class="fw-bold">
                {{ categoryName }} ({{ priceModelLabel }})
              </div>
              <div>{{ category.head }} ({{ category.id }})</div>
              <div>{{ cabinNumber }}</div>
            </div>
          </div>
        </template>
        <div 
          v-else 
          class="text-center fs-16 color-sachlich-grey"
        >
          'Lade Kategorien und Kabinen ...'
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useCabinStore, useDetailsStore } from '@/store';
import { mapPriceModelLabel } from '@/store/details/helper';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import { COMFORTAI, IND, INDAI } from '../../../general/master-data';
import Modal from '../../common/Modal.vue';

export default defineComponent({
  components: { Modal },

  data: () => {
    return {
      modal: false,
    }
  },

  computed: {
    ...mapState(useCabinStore, {
      category: store => store.category,
      cabin: store => store.cabin,
    }),
    ...mapState(useCabinStore, {
      selectedByUser: store => store.selectedByUser,
    }),
    ...mapState(useDetailsStore, {
      priceModel: store => store.priceModel,
    }),
    categoryName() {
      // TODO: check if mainName is still in use
      return this.category?.name || this.category?.mainName
    },
    cabinNumber() {
      if ([COMFORTAI, INDAI, IND].includes(this.priceModel!) && this.selectedByUser) {
        return `Kabine: ${this.cabin?.id}`
      }
      return ''
    },
    priceModelLabel() {
      return mapPriceModelLabel(this.priceModel!)
    },
  },

  methods: {
    toggleModal() {
      this.modal = !this.modal
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

img {
  cursor: zoom-in;
}

.magnifying-glass {
  font-size: 20px;
  right: 7px;
  bottom: 7px;
}

.description {
  flex: 1;
}

.modal-image-container {
  max-height: 65vh;
}
</style>
